const siteUrl = import.meta.env.VITE_SITE_URL || 'https://botan-buy.com';

const openingHours = [
  {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '10:00',
    closes: '19:00',
  },
  {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Saturday', 'Sunday', 'PublicHolidays'],
    opens: '10:00',
    closes: '19:00',
  },
];

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': `${siteUrl}/#website`,
  name: '株式会社BotaN',
  url: `${siteUrl}/`,
  description:
    '貴金属・ブランド品の出張買取「天神屋」とトレーディングカード専門店「まんがく」を運営する株式会社BotaN公式サイト。',
  inLanguage: 'ja',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${siteUrl}/#organization`,
  name: '株式会社BotaN',
  legalName: '株式会社BotaN',
  url: `${siteUrl}/`,
  logo: {
    '@type': 'ImageObject',
    url: 'https://static.readdy.ai/image/832753d55565bf6aa0b01904105ef45d/6818db7ce75617877ec23c1e2e2244ed.jpeg',
    width: 200,
    height: 200,
  },
  foundingDate: '2025-12',
  description:
    '福岡市を本拠地として、買取専門店「天神屋」とカードショップ「まんがく」の2事業を展開する会社。',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '港1-2-18-1712',
    addressLocality: '福岡市中央区',
    addressRegion: '福岡県',
    postalCode: '810-0075',
    addressCountry: 'JP',
  },
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '+81-92-577-9739',
      contactType: 'customer service',
      availableLanguage: 'Japanese',
      email: 'info@botan-buy.com',
      hoursAvailable: {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
        opens: '10:00',
        closes: '19:00',
      },
    },
  ],
  sameAs: [],
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: '事業一覧',
    itemListElement: [
      {
        '@type': 'OfferCatalog',
        name: '買取専門店 天神屋',
        description:
          '貴金属・宝石・ブランド品・カメラ・お酒・金券・骨董品・家電・楽器・電動工具・ゲーム・スマホ・タブレットの出張買取専門店',
      },
      {
        '@type': 'OfferCatalog',
        name: 'カードショップ まんがく',
        description:
          'ポケモンカード・ワンピースカード・ユニオンアリーナ・デュエルマスターズ・ヴァイスシュバルツを取り扱うカードショップ',
      },
    ],
  },
};

const tenjinyaSchema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${siteUrl}/#tenjin-ya`,
  name: '買取専門店 天神屋',
  description:
    '貴金属・宝石・ブランド品・カメラ・お酒・金券・骨董品・家電・楽器・電動工具・ゲーム・スマホ・タブレットの出張買取専門店。出張費・査定費無料。',
  url: `${siteUrl}/`,
  telephone: '+81-92-577-9739',
  email: 'info@botan-buy.com',
  image: 'https://static.readdy.ai/image/832753d55565bf6aa0b01904105ef45d/6818db7ce75617877ec23c1e2e2244ed.jpeg',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '港1-2-18-1712',
    addressLocality: '福岡市中央区',
    addressRegion: '福岡県',
    postalCode: '810-0075',
    addressCountry: 'JP',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 33.5902,
    longitude: 130.3738,
  },
  openingHoursSpecification: openingHours,
  areaServed: [
    { '@type': 'AdministrativeArea', name: '福岡県' },
    { '@type': 'AdministrativeArea', name: '福岡市' },
    { '@type': 'AdministrativeArea', name: '博多区' },
    { '@type': 'AdministrativeArea', name: '中央区' },
    { '@type': 'AdministrativeArea', name: '早良区' },
    { '@type': 'AdministrativeArea', name: '城南区' },
    { '@type': 'AdministrativeArea', name: '南区' },
  ],
  priceRange: '¥',
  currenciesAccepted: 'JPY',
  paymentAccepted: '現金',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: '買取品目',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '貴金属・宝石買取' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'ブランド品買取' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'カメラ買取' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'お酒・金券買取' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '骨董品・家電買取' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '楽器・電動工具買取' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'ゲーム・スマホ・タブレット買取' } },
    ],
  },
  parentOrganization: {
    '@type': 'Organization',
    '@id': `${siteUrl}/#organization`,
    name: '株式会社BotaN',
  },
};

const mangakuSchema = {
  '@context': 'https://schema.org',
  '@type': 'Store',
  '@id': `${siteUrl}/#mangaku`,
  name: 'カードショップ まんがく',
  description:
    'ポケモンカード・ワンピースカード・ユニオンアリーナ・デュエルマスターズ・ヴァイスシュバルツを取り扱うトレーディングカード専門店。',
  url: `${siteUrl}/`,
  telephone: '+81-92-577-9739',
  email: 'info@botan-buy.com',
  image: 'https://static.readdy.ai/image/832753d55565bf6aa0b01904105ef45d/6818db7ce75617877ec23c1e2e2244ed.jpeg',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '瓦町2-1-28 高尾ビル2F南',
    addressLocality: '高松市',
    addressRegion: '香川県',
    postalCode: '760-0023',
    addressCountry: 'JP',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 34.3401,
    longitude: 134.0434,
  },
  openingHoursSpecification: openingHours,
  areaServed: [
    { '@type': 'AdministrativeArea', name: '香川県' },
    { '@type': 'AdministrativeArea', name: '高松市' },
  ],
  priceRange: '¥',
  currenciesAccepted: 'JPY',
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: '取扱カードゲーム',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Product', name: 'ポケモンカードゲーム' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Product', name: 'ワンピースカードゲーム' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Product', name: 'ユニオンアリーナ' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Product', name: 'デュエルマスターズ' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Product', name: 'ヴァイスシュバルツ' } },
    ],
  },
  parentOrganization: {
    '@type': 'Organization',
    '@id': `${siteUrl}/#organization`,
    name: '株式会社BotaN',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '出張買取の費用はかかりますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '出張費用・査定費用は一切無料です。ご自宅や職場へ専門スタッフが伺い、無料で査定いたします。査定後に売却しないことも可能です。',
      },
    },
    {
      '@type': 'Question',
      name: 'どのようなものを買い取ってもらえますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '貴金属・宝石・ブランド品・カメラ・お酒・金券・骨董品・家電・楽器・電動工具・ゲーム・スマホ・タブレットなど幅広く対応しております。お手持ちの品についてはお気軽にご相談ください。',
      },
    },
    {
      '@type': 'Question',
      name: '買取金額はどのように決まりますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '市場価値、状態、ブランド・モデル・希少性などを総合的に判断して査定いたします。専門知識を持つスタッフが適正価格でご提示します。',
      },
    },
    {
      '@type': 'Question',
      name: 'カードショップまんがくでの買取は事前予約が必要ですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '事前予約なしで店頭にてカードの買取・販売を承っております。大量の場合は事前にご連絡いただけるとスムーズです。',
      },
    },
    {
      '@type': 'Question',
      name: 'まんがくではどのカードゲームを取り扱っていますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'ポケモンカード・ワンピースカード・ユニオンアリーナ・デュエルマスターズ・ヴァイスシュバルツを取り扱っております。',
      },
    },
    {
      '@type': 'Question',
      name: '買取の際に必要なものはありますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '身分証明書（運転免許証・マイナンバーカード等）が必要です。古物営業法の規定により、ご本人確認をお願いしております。',
      },
    },
    {
      '@type': 'Question',
      name: 'まとめ売りでの割増はありますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'まとめてお売りいただく場合、状況によって特別査定をご提示できる場合があります。まずはお気軽にご相談ください。',
      },
    },
  ],
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'ホーム',
      item: `${siteUrl}/`,
    },
  ],
};

const schemas = [websiteSchema, organizationSchema, tenjinyaSchema, mangakuSchema, faqSchema, breadcrumbSchema];

export default function SeoJsonLd() {
  return (
    <>
      {schemas.map((schema, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}
